/**
 * @generated SignedSource<<6ab8ebd5893ea51841f9cb5646cbcb8a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type GrantImpersonatePersonInput = {
  id: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type grantImpersonatePersonMutation$variables = {
  input: GrantImpersonatePersonInput;
};
export type grantImpersonatePersonMutation$data = {
  readonly GrantImpersonatePerson: {
    readonly missionControlData: {
      readonly eligibleForImpersonate: ReadonlyArray<{
        readonly id: string;
        readonly firstName: string | null;
        readonly lastName: string | null;
        readonly email: string | null;
      } | null> | null;
    } | null;
  } | null;
};
export type grantImpersonatePersonMutation = {
  variables: grantImpersonatePersonMutation$variables;
  response: grantImpersonatePersonMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "MissionControlImpersonatePersonType",
  "kind": "LinkedField",
  "name": "eligibleForImpersonate",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "grantImpersonatePersonMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "GrantImpersonatePersonPayload",
        "kind": "LinkedField",
        "name": "GrantImpersonatePerson",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "MissionControlDataType",
            "kind": "LinkedField",
            "name": "missionControlData",
            "plural": false,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "grantImpersonatePersonMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "GrantImpersonatePersonPayload",
        "kind": "LinkedField",
        "name": "GrantImpersonatePerson",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "MissionControlDataType",
            "kind": "LinkedField",
            "name": "missionControlData",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b187900096b8f454a89661e1679b34f7",
    "id": null,
    "metadata": {},
    "name": "grantImpersonatePersonMutation",
    "operationKind": "mutation",
    "text": "mutation grantImpersonatePersonMutation(\n  $input: GrantImpersonatePersonInput!\n) {\n  GrantImpersonatePerson(input: $input) {\n    missionControlData {\n      eligibleForImpersonate {\n        id\n        firstName\n        lastName\n        email\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "bd894758f39f90e6c3e20b96c5d5c1d9";

export default node;
